module.exports = __webpack_public_path__ + "img/skiing_1413_2.bc928d44.jpg";